import useIsSuperAdmin from 'src/modules/authentication/hooks/useIsSuperAdmin';
import useUserStorage from 'src/modules/authentication/storage/user/hook';
import { isRegisteredUser } from 'src/modules/authentication/storage/user/utils';
import useUnreadNotificationCount from 'src/modules/notification/hooks/useUnreadNotificationCount';
import { useRPPendingCountQuery } from 'src/modules/review-pipeline/graphql/pendingCount';
import { SupportedRPEntityTypes } from 'src/modules/review-pipeline/graphql/utils';
import useI18n from 'src/modules/translations/hooks/useI18n';
export default function usePrimaryNavContext() {
    const { translate } = useI18n();
    const [userDetails] = useUserStorage();
    const isSuperAdmin = useIsSuperAdmin();
    const [unreadCountState] = useUnreadNotificationCount();
    const [rpCountState] = useRPPendingCountQuery({
        skip: !isSuperAdmin,
        variables: {
            types: SupportedRPEntityTypes,
        },
        pollInterval: 5 * 60000,
    });
    return {
        translate,
        isRegistered: isRegisteredUser(userDetails),
        isSuperAdmin,
        isDev: __DEV__,
        unreadCount: unreadCountState.count,
        rpPendingCount: rpCountState.data?.rp_pendingCount,
    };
}
